import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, ChipsToggler } from '@common-fe/common-fe';

import { GroupServicesKey } from '@/modules/UseMyMoney/UseMyMoney.types';
import theme from '@/styles/theme';

interface Props {
  servicesGrouping: GroupServicesKey;
  setServicesGrouping: (groupingType: GroupServicesKey) => void;
}

const ServiceDescriptionFieldHeader: React.FC<Props> = ({ servicesGrouping, setServicesGrouping }) => {
  const { t } = useTranslation();

  const handleChangeGrouping = useCallback((newServicesGrouping: string) => {
    setServicesGrouping(newServicesGrouping as GroupServicesKey);
  }, [setServicesGrouping]);

  const options = useMemo(() => ([
    {
      key: GroupServicesKey.CATEGORY,
      title: t('Category'),
    },
    {
      key: GroupServicesKey.ACCOUNT,
      title: t('Account'),
    }
  ]), [t]);

  return (
    <Box margin={{ bottom: 'spacing12' }}>
      <ChipsToggler
        testId="services-grouping_dropdown-input"
        value={servicesGrouping}
        onChange={handleChangeGrouping}
        options={options}
        buttonStyle={{
          padding: `${theme.spacings.spacing4} ${theme.spacings.spacing8}`,
        }}
        textStyle={{
          fontSize: theme.fonts.text12Medium['font-size'],
        }}
      />
    </Box>
  );
};

export default ServiceDescriptionFieldHeader;
